<template>
  <span class="inline-block relative">
    <img v-if="isHas" class="rounded-full" :class="cls" :src="link" alt="user"/>
    <span v-else :class="[cls, bg]" class="inline-flex items-center justify-center rounded-full select-none">
      <span class="text-xs font-medium leading-none text-white">{{ letters }}</span>
    </span>
    <span v-if="online" class="absolute bottom-0 right-0 block h-2 w-2 rounded-full ring-2 ring-white"
          :class="[online? 'bg-green-400' : 'bg-gray-400']"/>
  </span>

</template>

<script>
const colors = {
  'а': 'bg-gray-800',
  'б': 'bg-red-800',
  'в': 'bg-yellow-800',
  'г': 'bg-green-800',
  'д': 'bg-blue-800',
  'е': 'bg-indigo-800',
  'ё': 'bg-pink-800',
  'ж': 'bg-purple-800',
  'з': 'bg-cyan-800',
  'и': 'bg-rose-800',
  'й': 'bg-orange-800',
  'к': 'bg-amber-800',
  'л': 'bg-amber-800',
  'м': 'bg-red-800',
  'н': 'bg-yellow-800',
  'о': 'bg-blue-800',
  'п': 'bg-indigo-800',
  'р': 'bg-pink-800',
  'с': 'bg-purple-800',
  'т': 'bg-cyan-800',
  'у': 'bg-rose-800',
  'ф': 'bg-orange-800',
  'х': 'bg-amber-800',
  'ц': 'bg-gray-800',
  'ш': 'bg-red-800',
  'щ': 'bg-yellow-800',
  'ъ': 'bg-green-800',
  'ы': 'bg-blue-800',
  'ь': 'bg-indigo-800',
  'э': 'bg-pink-800',
  'ю': 'bg-purple-800',
  'я': 'bg-cyan-800',
}


export default  {
  name: "UiAvatarCircular",
  setup() {
    return {colors}
  },
  props: {
    link: {
      default: ''
    },
    name: {
      default: '',
      required: true
    },
    online: {
      default: false
    },
    cls: {
      default: 'h-6 w-6'
    }
  },
  computed: {
    isHas() {
      return this.link.length > 0
    },
    letters() {
      /*return String(this.name).split(' ').map(function (item) {
        return item[0]
      }).join('')*/
      const l = this.name[0] ?? ''
      return l.toUpperCase();
    },
    bg() {
      const key = this.letters.toLowerCase()
      if (key in colors)
        return colors[key]
      return 'bg-primary-800'
    }

  }
}
</script>

<style scoped>

</style>